import { createSlice } from '@reduxjs/toolkit';
import { AsyncStatus } from '../../../../libs/utils/constants/async-status';
import ISkillFavoriteContent from '../../../../libs/utils/interfaces/favorite-content-interface';
import {
    getUserFavoriteContent,
    deleteFavoriteContent,
} from './skills-favorite-tab-thunk';

const initialState: ISkillFavoriteContent = {
    asyncStatus: AsyncStatus.INITIAL,
    favoriteSkillList: [],
    favoritePatientEducationList: [],
    skillListCount: 0,
    patientEducationListCount: 0,
    statusCode: 0,
    deleteAsyncStatus: AsyncStatus.INITIAL,
};

const userFavoriteContentSlice = createSlice({
    name: 'userFavoriteContent',
    initialState,
    reducers: {
        resetDeleteStatus: (state) => {
            state.deleteAsyncStatus = AsyncStatus.INITIAL;
        },
    },
    extraReducers: (builder: any) => {
        builder
            // Get User Favorite Content
            .addCase(
                getUserFavoriteContent.pending,
                (state: ISkillFavoriteContent) => {
                    state.asyncStatus = AsyncStatus.LOADING;
                    state.skillListCount = 0;
                    state.patientEducationListCount = 0;
                    state.statusCode = 0;
                }
            )
            .addCase(
                getUserFavoriteContent.fulfilled,
                (state: ISkillFavoriteContent, { payload }: any) => {
                    state.asyncStatus = AsyncStatus.SUCCESS;
                    state.statusCode = payload.status;
                    if (payload.status === 204) {
                        state.favoriteSkillList = [];
                        state.skillListCount = 0;
                        state.favoritePatientEducationList = [];
                        state.patientEducationListCount = 0;
                    } else {
                        state.favoriteSkillList =
                            payload.data.userFavoriteSkillList;
                        state.skillListCount =
                            payload.data.userFavoriteSkillList.length;
                        state.favoritePatientEducationList =
                            payload.data.patientEducationSkillList;
                        state.patientEducationListCount =
                            payload.data.patientEducationSkillList.length;
                    }
                }
            )
            .addCase(
                getUserFavoriteContent.rejected,
                (state: ISkillFavoriteContent) => {
                    state.asyncStatus = AsyncStatus.FAILURE;
                    state.skillListCount = 0;
                    state.patientEducationListCount = 0;
                    state.statusCode = 0;
                }
            )
            // Delete User Favorite Content
            .addCase(
                deleteFavoriteContent.pending,
                (state: ISkillFavoriteContent) => {
                    state.deleteAsyncStatus = AsyncStatus.LOADING;
                }
            )
            .addCase(
                deleteFavoriteContent.fulfilled,
                (state: ISkillFavoriteContent) => {
                    state.deleteAsyncStatus = AsyncStatus.SUCCESS;
                }
            )
            .addCase(
                deleteFavoriteContent.rejected,
                (state: ISkillFavoriteContent) => {
                    state.deleteAsyncStatus = AsyncStatus.FAILURE;
                }
            );
    },
});

export const { resetDeleteStatus } = userFavoriteContentSlice.actions;
export default userFavoriteContentSlice.reducer;
